<div style="padding: 24px 2px 40px 20px">
  <nz-steps
    [nzCurrent]="currentIndex"
    [nzLabelPlacement]="'vertical'"
    class="comparative-analysis-steps-container"
  >
    <nz-step nzTitle="Company Selection" class="comparative-step-1-title">
    </nz-step>
    <nz-step
      nzTitle="Line Item & Period Selection"
      class="comparative-step-2-title"
    ></nz-step>
    <nz-step
      nzTitle="Title of new Analysis"
      class="comparative-step-3-title"
    ></nz-step>
  </nz-steps>
</div>

<div
  [ngSwitch]="currentIndex"
  [ngClass]="{
    'step-1-content': currentIndex === 0,
    'step-2-content': currentIndex === 1,
    'step-3-content': currentIndex === 2
  }"
>
  <div *ngSwitchCase="0">
    <app-comparative-ticker-modal
      [addRowTableData]="addRowTableData"
      [recentlyVisitedCompanies]="recentlyVisitedCompanies"
      [mpt]="mpt"
      [isTickerTypeBg]="isTickerTypeBg"
      [industryData]="industryData"
      [watchlistData]="watchlistData"
      [marketGeoData]="marketGeoData"
      [menuList]="menuList"
      (tickerUpdate)="onTickerUpdate($event)"
      (mptUpdate)="onMptUpdate($event)"
      type="create"
      maxHeight="200px"
      [maxTickers]="maxTickers"
      [isCreateNewModalIndustryMenu]="isCreateNewModalIndustryMenu"
      [showSaveWatchList]="showSaveWatchList"
    >
    </app-comparative-ticker-modal>
  </div>
  <div *ngSwitchCase="1">
    <app-line-item-modal
      [addColTableData]="addColTableData"
      [stdLineItems]="stdLineItems"
      [max]="max"
      [createSource]="createSource"
      maxHeight="180px"
      lineItemInputId="createNewCompsWizardLineItemInput"
      [tickers]="tickers"
      [marketItemsData]="marketItemsData"
      placeholder="Search line items or lists"
      (updateComp)="onUpdateComp($event)"
    >
    </app-line-item-modal>
    <va-period-filter
      [periodData]="yearTypeData"
      className="line-modal-period-filter"
      (onApply)="handlePeriodApply($event)"
      [popoverPlacement]="'topLeft'"
      [filterWidthVariation]="3"
      [periodMinMax]="periodMinMax"
      [dataAvailable]="periodsWithAvailableDataForPopup"
    ></va-period-filter>
  </div>
  <div *ngSwitchCase="2">
    <div class="analysis-template">
      <div class="name-custom-analysis">
        <div>
          <div style="color: black">Name your new Custom Analysis</div>
          <input
            nz-input
            placeholder="Enter title"
            class="custom-analysis-input"
            [(ngModel)]="tabName"
          />
          <va-icon
            size="small"
            name="search"
            class="fa-sm search-icon"
          ></va-icon>
        </div>
        <div *ngIf="isDuplicateName" class="duplicate-error-msg">
          <va-icon size="small" name="exclamation-triangle"></va-icon>
          {{ duplicateErrorMsg }}
        </div>
      </div>
    </div>
  </div>
</div>
